import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../App.css';

const UpgradePrompt = ({ feature, onClose }) => {
  const navigate = useNavigate();

  return (
    <div className="upgrade-prompt-overlay">
      <div className="upgrade-prompt">
        <h3>Upgrade to access {feature}</h3>
        <p>Unlock this feature with an Owner-Operator or Fleet plan.</p>
        <div className="upgrade-prompt-actions">
          <button className="button secondary" onClick={onClose}>
            Maybe later
          </button>
          <button className="button primary" onClick={() => navigate('/pricing')}>
            View plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradePrompt;
